export type UseSchedulingUnavailableReturn = {
  title: string
  message: string
}

export function useSchedulingUnavailable(): UseSchedulingUnavailableReturn {
  return {
    title: 'This link is no longer available',
    message: 'It seems like the online scheduler you are looking for is no longer at this link.',
  }
}
